module.exports = __webpack_public_path__ + "static/UT_1P_modern_v2-65b540a4ce4384cde34a6af6dbd894a8.png";